// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2yM7j","container":"styles_container__2M1Dm","title":"styles_title__28mdy","wrapper":"styles_wrapper__SANqE","answer":"styles_answer__HDGqd"};